<template>
    <div class="home-container">
        <div class="home-top-box">
            <div class="search-box">
                <div class="search-input-box">
                    <input
                        class="search-word-input"
                        type="text"
                        @focus="toSeach"
                        placeholder="搜索元器件型号、参数…"
                    />
                </div>
                <div class="search-sumbit-btn" @click="toSeach"></div>
            </div>
        </div>
        <div class="home-main-box">
            <div class="swipe-box">
                <van-swipe :autoplay="3000" indicator-color="#4bc227">
                    <van-swipe-item
                        v-for="(item, index) in bannerList"
                        :key="index"
                    >
                        <a :href="item.clickUrl" v-if="item.clickUrl">
                            <img
                                class="swiper-item-cover"
                                :src="$config.QINIU_URL + item.picFilePath"
                            />
                        </a>
                        <a :href="item.clickUrl" v-else>
                            <img
                                class="swiper-item-cover"
                                :src="$config.QINIU_URL + item.picFilePath"
                            />
                        </a>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="contact-box">
                <div class="iocq-box">
                    <a href="javascript:void(0)">800158062</a>
                </div>
                <div class="phone-box">
                    <a href="tel:0755-82538015">0755-82538015</a>
                </div>
            </div>
            <div class="order-statistics-box">
                <div class="statistics-item-box">
                    <div class="text-1">
                        {{ orderStatisticsInfo.currDayOrderCount }}
                        <em>单</em>
                    </div>
                    <div class="text-2">今天</div>
                </div>
                <div class="statistics-item-box">
                    <div class="text-1">
                        {{ orderStatisticsInfo.beforeDayOrderCount }}
                        <em>单</em>
                    </div>
                    <div class="text-2">近3天</div>
                </div>
                <div class="statistics-item-box">
                    <div class="text-1">
                        {{ orderStatisticsInfo.beforeMonthOrderCount }}
                        <em>单</em>
                    </div>
                    <div class="text-2">近30天</div>
                </div>
            </div>
            <div class="product-box">
                <div class="product-box">
                    <ul class="product-list">
                        <li
                            class="product-item"
                            @click="
                                $router.push({
                                    path: '/product/info',
                                    query: {
                                        id: item.productId,
                                    },
                                })
                            "
                            v-for="(item, index) in productList"
                            :key="index"
                        >
                            <div class="product-cover">
                                <img :src="$config.QINIU_URL + item.filePath" />
                            </div>
                            <div class="product-info">
                                <div class="product-name">
                                    <span>{{ item.label }}</span>
                                </div>
                                <div class="product-params">
                                    <span class="tax-number"
                                        >含税单价({{
                                            $config.TAX_NUMBER
                                        }}%)</span
                                    >
                                    <span class="min-price"
                                        >￥{{ item.price }}</span
                                    >
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <foot-bar></foot-bar>
    </div>
</template>

<script>
const default_order_statistics = {
    currDayOrderCount: 0,
    beforeDayOrderCount: 0,
    beforeMonthOrderCount: 0,
};
import { createBasket, isLogin, getUserToken } from "@/utils/auth";
import FootBar from "@/components/FootBar";
import Vue from "vue";
import { Swipe, SwipeItem, Toast } from "vant";
Vue.use(Swipe)
    .use(SwipeItem)
    .use(Toast);
export default {
    name: "IndexPage",
    components: {
        FootBar,
    },
    data() {
        return {
            productList: [],
            bannerList: [],
            orderStatisticsInfo: default_order_statistics,
        };
    },
    beforeMount() {
        this.getHomeDatas();
    },
    mounted() {},
    methods: {
        /**
         * @description 跳转到search页面
         */
        toSeach() {
            this.$router.push({ path: "/product/search" });
        },
        /**
         * @description 获取首页数据
         */
        async getHomeDatas() {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let orderStatisticsData = await this.getOrderStatistics();
            let productListData = await this.getProductList();
            let bannerData = await this.getBannerList();
            this.orderStatisticsInfo = Object.assign(
                default_order_statistics,
                orderStatisticsData.data || {}
            );
            let productlist = productListData.data || [];
            let productTemp = [];
            productlist.forEach((list) => {
                productTemp.push(...list);
            });
            this.productList = productTemp || [];
            this.bannerList = bannerData.data || [];
            this.$toast.clear();
        },
        /**
         * @description 获取订单统计
         */
        getOrderStatistics() {
            let _this = this;
            return this.$axios.post(_this.$api.homeApi.getOrderStatistics);
        },
        /**
         * @description 获取商品列表
         */
        getProductList() {
            let _this = this;
            return this.$axios.post(_this.$api.homeApi.getProductList);
        },
        /**
         * @description 获取轮播图
         */
        getBannerList() {
            let _this = this;
            const mobileId = 39;
            return this.$axios.post(_this.$api.homeApi.getBanner, {
                adId: mobileId,
            });
        },
        openOicq(qq) {
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
                if (
                    u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
                ) {
                    window.open(
                        `http://wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`
                    );
                } else {
                    window.open(
                        `mqqwpa://im/chat?chat_type=wpa&uin=${qq}&version=1&src_type=web&web_src=oicqzone.com`
                    );
                }
            } else {
                if (
                    u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
                ) {
                    window.open(
                        `http://wpa.qq.com/msgrd?v=3&uin=${qq}&site=qq&menu=yes`
                    );
                } else {
                    window.open(
                        `mqqwpa://im/chat?chat_type=wpa&uin=${qq}&version=1&src_type=web&web_src=oicqzone.com`
                    );
                }
            }
        },
    },
};
</script>
<style lang="less" scope>
.home-container {
    width: 100%;
    padding-bottom: 100px;
    .home-top-box {
        overflow: hidden;
        height: 420px;
        background-color: #fff;
        background-image: url("../../public/images/common/logo.png");
        background-repeat: no-repeat;
        background-size: 354px 128px;
        background-position: center 80px;
        .search-box {
            margin: 280px auto 0;
            width: 690px;
            height: 80px;
            border: 1px solid #666;
            .search-input-box {
                float: left;
                height: 80px;
                width: 570px;
                .search-word-input {
                    border: none;
                    height: 78px;
                    width: 535px;
                    padding-left: 35px;
                    background-color: transparent;
                    font-size: 28px;
                    line-height: 80px;
                    color: #999;
                }
            }
            .search-sumbit-btn {
                float: right;
                width: 117px;
                height: 80px;
                border-left: 1px solid #dedede;
                background-image: url("../../public/images/index/search-icon.png");
                background-size: 45px;
                background-position: center;
                background-repeat: no-repeat;
                cursor: pointer;
            }
        }
    }
}
.home-main-box {
    margin: 20px auto 0;
    padding: 30px;
    background-color: #fff;
    .swipe-box {
        width: 690px;
        height: 240px;
        .swiper-item-cover {
            width: 690px;
            height: 240px;
            display: block;
        }
    }
    .contact-box {
        padding: 30px 0;
        height: 100px;
        .iocq-box {
            float: left;
            width: 340px;
            height: 100px;
            background-color: #e5f3fe;
            background-image: url("../../public/images/index/qq-icon.png");
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: 50px center;
            border-radius: 5px;
            a {
                display: block;
                padding-left: 120px;
                width: 220px;
                height: 100px;
                font-size: 28px;
                line-height: 100px;
                font-weight: 400;
                color: #4098f0;
            }
        }
        .phone-box {
            float: right;
            width: 340px;
            height: 100px;
            background-color: #ddfee8;
            background-image: url("../../public/images/index/phone-icon.png");
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: 50px center;
            border-radius: 5px;
            a {
                display: block;
                padding-left: 120px;
                width: 220px;
                height: 100px;
                font-size: 28px;
                line-height: 100px;
                font-weight: 400;
                color: #15c955;
            }
        }
    }
    .order-statistics-box {
        height: 130px;
        border-bottom: 1px solid #dedede;
        .statistics-item-box {
            float: left;
            width: 33.3%;
            height: 130px;
            .text-1 {
                font-size: 34px;
                line-height: 60px;
                text-align: center;
                color: #333;
                em {
                    padding-left: 10px;
                    font-size: 28px;
                    font-style: normal;
                }
            }
            .text-2 {
                font-size: 28px;
                text-align: center;
                color: #999;
            }
        }
    }
    .product-box {
        .product-list {
            .product-item {
                overflow: hidden;
                padding: 30px 0;
                width: 690px;
                border-bottom: 1px solid #f2f2f2;
                .product-cover {
                    float: left;
                    width: 120px;
                    height: 120px;
                    img {
                        display: block;
                        width: 120px;
                        height: 120px;
                    }
                }
                .product-info {
                    float: right;
                    width: 540px;
                    .product-name {
                        font-size: 26px;
                        line-height: 1.5;
                        word-break: break-all;
                        text-align: left;
                        font-weight: 500;
                    }
                    .product-params {
                        margin-top: 10px;
                        font-size: 24px;
                        text-align: left;
                        .tax-number {
                            color: #999;
                        }
                        .min-price {
                            padding-left: 38px;
                            color: #ff5500;
                        }
                    }
                }
            }
        }
    }
}
</style>
